import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const HeadingsTitleSearchFormField = ({ input, placeholder, type, name, label, clang, meta: { touched, error } }) => {
    return (
        <div className="headings-search__form-field">
            <label className="headings-search__form-label">
                <span className="headings-search__label-text">{label}</span>
                <input name={name} {...input}
                title={placeholder}
                type={type}
                placeholder={placeholder}
                className="headings-search__form-input"/>
            </label>
        </div>
    );
};

HeadingsTitleSearchFormField.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(HeadingsTitleSearchFormField);



// WEBPACK FOOTER //
// ./src/components/characteristics/HeadingsTitleSearchFormField.js